import { createContext, useContext } from 'react'
export const AssetPriceSessionContext = createContext(null)
export const useAssetPriceSession = () => useContext(AssetPriceSessionContext)
